export const DATE_FORMAT = 'DD/MM/YYYY';
export const LONG_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DEFAULT_INTERVAL_MODIFICATION = 42;
export const DEFAULT_GRID_HEADER_HEIGHT = 50;
export const DEFAULT_GRID_ROW_HEIGHT = 56;
export const GRID_ROW_HEIGHT_SMALL = 42;